import React from 'react';

import Select from '~/components/forms/Select';

/**
 * PROPS
 * filters = array of objects
 * onChange(filterName, value) = func
 */

const CoursePlaybillFilter = props => {
  const filters = props.filters.map(f => {
    const parsedValue =
      f?.value && f?.value instanceof Array ? f.value : [f.value];

    switch (f.type) {
      case 'select':
        return (
          <Select
            key={f.name}
            label={f.label}
            value={parsedValue || ''}
            options={f.options}
            onChange={val => props.onChange(f.name, val)}
          />
        );
      default:
        return null;
    }
  });

  return <div className="select-wrap__for-course-reg">{filters}</div>;
};

export default CoursePlaybillFilter;
